<template>
  <el-table-column v-if="editable===false"
    :label="label"
    :width="width"
    :prop="prop"
    :sortable="sortable"
  />
  <el-table-column v-else
    :label="label"
    :width="width"
    :prop="prop"
    :sortable="sortable"
  >
    <template slot-scope="scope">
      <el-form-item
        :prop="tableDataName + '.' + scope.$index + '.' + prop"
        :rules="rules"
      >
          <!-- :value="getter(scope.row[prop])" -->
        <!-- <el-input
          v-model="scope.row[prop]"
          @input="setter"
          type="text"
          :clearable="true"
          :maxlength="maxlength"
          resize="none"
          :placeholder="placeholder"
          :disabled="disabled"
          :autofocus="autofocus"
          :validator="validator"
          :uppercase="uppercase"
        >
        </el-input> -->
        <el-select
          v-model="scope.row[prop]"
          @input="setter"
          :placeholder="placeholder"
          :disabled="disabled === true ? disabled : addRowMode === false ? disabled : !changeable(addRowMode, changeCase, tableDataCount, scope.$index)"
          :autofocus="autofocus"
          :required="required"
          :options="options"
          :clearable="false"
          :filterable="false"
        >
          <el-option v-if="!required" label="" value="" />
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <span style="float: left; color: #8492a6; font-size: 13px">{{item.value}}</span>
            <span style="float: left; margin-left: 10px">{{item.label}}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </template>
  </el-table-column>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    label: {
      type: String,
      default: 'プルダウン'
    },
    prop: {
      type: String,
      default: 'code'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    // uppercase: {
    //   type: Boolean,
    //   default: false
    // },
    validator: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: ''
    },
    addRowMode: {
      type: Boolean,
      default: false
    },
    changeable: {
      type: Function,
      default: () => true
    },
    changeCase: {
      type: String,
      default: ''
    },
    tableDataCount: {
      type: Number,
      default: 0
    },
    tableDataName: {
      type: String,
      default: 'tableData'
    },
    codeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    // select: {
    //   get () {
    //     return this.value
    //   },
    //   set (select) {
    //     this.$emit('change', select)
    //     this.options = this.optionsOriginal
    //   }
    // },
    rules: {
      get () {
        const rules = []
        // if (!this.disabled) {
        if (this.required) {
          rules.push(this.validatorRequired(this.label, 'change'))
        }
        // }
        return rules
      }
    }
  },
  async mounted () {
    const root = document.documentElement
    root.style.setProperty('--width', this.width)
    const selectList = await this.loadCode()
    const selectListSet = selectList.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = selectListSet
    this.optionsOriginal = selectListSet
  },
  methods: {
    getter (value) {
      return value
    },
    setter (value) {
      // this.$emit('input', value)
      this.$emit('change', value)
      this.options = this.optionsOriginal
    },
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: this.codeId } })
          .then((res) => {
            // sessionStorage.setItem('selectList', JSON.stringify(res.data.list))
            sessionStorage.setItem('CodeColumn_' + this.prop, JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      // return JSON.parse(sessionStorage.getItem('selectList'))
      return JSON.parse(sessionStorage.getItem('CodeColumn_' + this.prop))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:root {
  --width: 100px;
}
.el-table {
  th,
  td {
    &.code-column {
      width: var(--width);
    }
  }
}
</style>
